module.exports = __webpack_public_path__ + "img/1583714661.ae6659ef.jpg";